import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../images/logo.png";

const SignupCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#faf7f5] flex flex-col items-center justify-center px-4">
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-10"
      >
        <img src={logo} alt="Furbabies.AI" className="w-28 h-28 mx-auto" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 280, damping: 25 }}
        className="bg-white border border-[#e8ddd6] rounded-2xl shadow-sm px-10 py-12 max-w-md w-full text-center"
      >
        {/* Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 400, damping: 20, delay: 0.1 }}
          className="w-16 h-16 bg-[#f5ede7] rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <svg className="w-8 h-8 text-[#967d6c]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L13 17h-2l-2 2H7l-3-3v-2l.758-.758M3 3l18 18M6.343 6.343a8 8 0 1011.314 11.314" />
          </svg>
        </motion.div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2">Payment cancelled</h2>
        <p className="text-gray-500 poppins-text text-sm mb-2">
          No worries — you haven't been charged. Your information is safe.
        </p>
        <p className="text-gray-400 poppins-text text-xs mb-8">
          Whenever you're ready, you can come back and complete your signup. Your details are still saved.
        </p>

        <div className="flex flex-col gap-3">
          {/* Primary: retry checkout */}
          <motion.button
            whileHover={{ backgroundColor: "#BDA697" }}
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate("/signup")}
            className="w-full bg-[#967d6c] text-white py-3 rounded-xl poppins-text font-medium text-sm flex items-center justify-center gap-2"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Try again
          </motion.button>

          {/* Secondary: back to home */}
          <motion.button
            whileHover={{ backgroundColor: "#f0e9e4" }}
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate("/")}
            className="w-full bg-white border border-[#e8ddd6] text-gray-600 py-3 rounded-xl poppins-text text-sm"
          >
            Back to home
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default SignupCancel;